import DiscardedMailsTable from "./discarded-mails-table";

export default DiscardedMailsTable